import React, { useEffect, useState } from 'react'

import { Button, ButtonVariant } from '@amzn/stencil-react-components/button'
import {
    IconBookmarkFillSmall as IconBookmarkFill,
    IconBookmarkSmall as IconBookmark,
} from '@amzn/stencil-react-icons'

import { NotificationServiceClient } from 'src/services/notificationServiceClient'

const ENTITY_TYPE = 'module'

interface BookmarkButtonProps {
    moduleId: string
    moduleName: string
}

export const BookmarkButton = ({ moduleId, moduleName }: BookmarkButtonProps) => {
    const [isFollowing, setIsFollowing] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true)

    useEffect(() => {
        let cancelled = false
        NotificationServiceClient.checkFollowingEntity({
            entityType: ENTITY_TYPE,
            entityId: moduleId,
        })
            .then((following) => {
                if (!cancelled) setIsFollowing(following)
            })
            .catch(() => {})
            .finally(() => {
                if (!cancelled) setLoading(false)
            })
        return () => {
            cancelled = true
        }
    }, [moduleId])

    const handleClick = async () => {
        setLoading(true)
        try {
            if (isFollowing) {
                await NotificationServiceClient.unfollowEntity({
                    entityType: ENTITY_TYPE,
                    entityId: moduleId,
                })
                setIsFollowing(false)
            } else {
                await NotificationServiceClient.followEntity({
                    entityType: ENTITY_TYPE,
                    entityId: moduleId,
                    entityName: moduleName,
                })
                setIsFollowing(true)
            }
        } catch {
            // leave state unchanged on error
        } finally {
            setLoading(false)
        }
    }

    return (
        <Button
            variant={ButtonVariant.Secondary}
            icon={
                isFollowing ? (
                    <IconBookmarkFill title='Remove bookmark' color='primary70' />
                ) : (
                    <IconBookmark title='Bookmark module' />
                )
            }
            style={{ borderRadius: '50%' }}
            dataTestId='bookmark-module-button'
            onClick={handleClick}
            disabled={loading}
            aria-label={isFollowing ? 'Remove bookmark' : 'Bookmark module'}
            aria-pressed={isFollowing}
        />
    )
}
